import axiosInstance from './axiosInstance';

// Leaderboard boards (top sales, rookies, million-dollar achievers, teams).
export const getRankings = () => axiosInstance.get('/Rankings/GetAll');

// Per-user earned leaderboard titles + current sales tier ("Title Ranking").
// Pass a userId for one user (profile); omit for all users (export).
export const getLeaderboardTitles = (userId) =>
    axiosInstance.get('/Rankings/GetLeaderboardTitles', { params: userId ? { userId } : {} });
